import { gql, useQuery } from '@apollo/client';
import { BoxProps } from '@chakra-ui/react';
import * as React from 'react';

import {
  PinnedPost_GetPostsV2,
  PinnedPost_GetPostsV2Variables,
} from './graphql-types/PinnedPost_GetPostsV2';

import { Post } from '../Post';

const GET_POSTS = gql`
  query PinnedPost_GetPostsV2($input: MultiPostInputV2!) {
    postsV2(input: $input) {
      results {
        _id
        ...Post_PostV2Fragment
      }
    }
  }
  ${Post.postFragment}
`;

export const PinnedPost: React.FC<
  {
    groupId: string;
  } & BoxProps
> = ({ groupId, ...boxProps }) => {
  const { error, loading, data } = useQuery<
    PinnedPost_GetPostsV2,
    PinnedPost_GetPostsV2Variables
  >(GET_POSTS, {
    variables: {
      input: {
        filter: {
          groupId: { _eq: groupId },
          pinned: { _eq: true },
          _hideDeleted: { hide: true },
        },
        limit: 1,
      },
    },
  });

  if (loading) {
    return null;
  }

  if (error) {
    throw error;
  }

  if (!data?.postsV2?.results || data.postsV2.results.length === 0) {
    return null;
  }

  const pinnedPost = data.postsV2.results[0];

  return <Post post={pinnedPost} {...boxProps} />;
};
